// signature-pad.component.ts

import {
  Component,
  ElementRef,
  ViewChild,
  AfterViewInit,
  AfterViewChecked,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';
import SignaturePad from 'signature_pad';

@Component({
  selector: 'app-signature-pad',
  templateUrl: './signature-pad.component.html',
  styleUrls: ['./signature-pad.component.scss']
})
export class SignaturePadComponent implements AfterViewInit, AfterViewChecked, OnChanges {
  @ViewChild('signaturePad', { static: true }) signaturePadElementRef: ElementRef;
  @Output() signatureSaved: EventEmitter<string> = new EventEmitter<string>();
  @Input() parentWidth: number = 400;
  /**
   * Drawing height in CSS pixels. The canvas is not scaled by CSS, so this is
   * the surface itself — a box shorter than this cannot be drawn on below its
   * own edge. 250 is what every caller got before it could be set.
   */
  @Input() parentHeight: number = 250;
  @Input() generate;
  previousSign: string = '';

  signaturePad: SignaturePad;

  private pendingStrokeRestore: ReturnType<SignaturePad['toData']> | null = null;
  /** Canvas width/height inputs changed; the bitmap is wiped on the next view check. */
  private canvasSizeDirty = false;
  private destroyed = false;
  private clearNotifyTimer: number | null = null;

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.signaturePad) {
      return;
    }
    if (changes['parentWidth'] || changes['parentHeight']) {
      if (!this.signaturePad.isEmpty()) {
        this.pendingStrokeRestore = this.signaturePad.toData();
      }
    }
  }

  ngAfterViewChecked(): void {
    if (!this.pendingStrokeRestore || !this.signaturePad) {
      return;
    }
    const strokes = this.pendingStrokeRestore;
    this.pendingStrokeRestore = null;
    this.fillWhiteBackground();
    this.signaturePad.fromData(strokes);
  }

  ngAfterViewInit(): void {
    this.signaturePad = new SignaturePad(this.signaturePadElementRef.nativeElement);
    const canvas = this.signaturePadElementRef.nativeElement;

    this.fillWhiteBackground();

    canvas.addEventListener('mousemove',()=>{
      if(!this.signaturePad.isEmpty()) {
        this.save();
      }
    });

    canvas.addEventListener('mouseleave',()=>{
      console.log("read!!!!!!!");
      if(!this.signaturePad.isEmpty()) {
        this.save();
      }
    });

    canvas.addEventListener('touchend',()=>{
      if(!this.signaturePad.isEmpty()) {
        this.save();
      }
    });
    
  }

  private fillWhiteBackground(): void {
    const canvas = this.signaturePadElementRef.nativeElement;
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      return;
    }
    ctx.fillStyle = 'white';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  }

  clear(): void {
    this.signaturePad.clear();
  }

  save(): void {
    const dataURL = this.signaturePad.toDataURL();
    if(this.previousSign == dataURL) {
      return
    }
    this.previousSign = dataURL;
    this.signatureSaved.emit(dataURL)
    // You can send this dataURL to your backend for further processing/storage
  }
}
